import { FC } from "react";
import { TextSkeleton } from "./TextSkeleton";
import { useTeam } from "../hooks/useTeam.ts";

export const TeamName: FC<{
  teamId: string;
  short?: boolean;
  variant?: "full" | "medium" | "short";
}> = (props) => {
  const { teamId, short } = props;
  const team = useTeam(teamId);

  if (!team.isSuccess) {
    return <TextSkeleton>Name</TextSkeleton>;
  }

  if (short !== undefined) {
    return short ? team.data.shortName : team.data.name;
  }

  const variant = props.variant ?? "full";

  switch (variant) {
    case "full":
      return team.data.name;
    case "medium":
      return team.data.mediumName;
    case "short":
      return team.data.shortName;
  }
};
